var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "shensu-info" },
    [
      _c("div", { staticClass: "form-row" }, [
        _c("div", { staticClass: "lable" }, [
          _vm._v("系统判断当前订单的提成类型为"),
          _c("span", { staticClass: "danger" }, [
            _vm._v(_vm._s(_vm.orderObj.bonusTypeLabel)),
          ]),
          _vm._v(
            "，若您认为是" + _vm._s(_vm.newResult.label) + "提成请上传证据。"
          ),
        ]),
      ]),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "130px" },
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "images",
              staticStyle: { "line-height": "1", "margin-bottom": "14px" },
              attrs: { label: "上传图片证件", prop: "fileUrls" },
            },
            [
              _c("div", { staticClass: "info" }, [
                _vm._v(
                  "（图片最多不超过6张，每张大小不超2M，图片格式支持jpg，jpeg，bmp）"
                ),
              ]),
              _c("upload-picture", {
                staticClass: "upload-list",
                attrs: { limit: 6, list: _vm.form.fileUrls },
                on: { changeImage: _vm.changeImage },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "修改备注" } },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "64",
                  "show-word-limit": "",
                  placeholder: "请输入备注",
                  type: "textarea",
                },
                model: {
                  value: _vm.form.reason,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "reason", $$v)
                  },
                  expression: "form.reason",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "button-con button-con-right" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-cancel",
              on: {
                click: function ($event) {
                  return _vm.$emit("dialogVisible")
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              staticClass: "btn-ok",
              attrs: { type: "primary" },
              on: { click: _vm.submit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }